import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#FFFBF5] flex flex-col" data-testid="not-found-page">
      <Navbar />
      <main className="flex-1 flex items-center justify-center px-6 py-20">
        <div className="max-w-xl w-full text-center">
          <p className="caption-label text-[#A26F3E]">Erreur 404</p>
          <h1 className="font-serif text-6xl sm:text-7xl text-[#1A1A1A] mt-3 leading-none tracking-tight">
            Page introuvable
          </h1>
          <p className="text-[#6E4B2A] mt-5 leading-relaxed">
            La page que vous cherchez n'existe pas ou a été déplacée. Revenez à l'accueil pour continuer votre exploration.
          </p>
          <Link to="/">
            <Button className="mt-8 rounded-full bg-[#C68E59] hover:bg-[#A26F3E] text-white h-12 px-8" data-testid="not-found-home-btn">
              <Home className="w-4 h-4 mr-2" /> Retour à l'accueil
            </Button>
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
